import { ComponentType, ReactNode } from 'react'
import styles from './comparison.module.scss'

type Props<T = any> = {
  leftTitle?: string
  rightTitle?: string
  leftContent?: ReactNode
  rightContent?: ReactNode
  component?: ComponentType<T>
  commonProps?: Partial<T>
  leftProps?: Partial<T>
  rightProps?: Partial<T>
}

export const ComparisonContainer = <T extends object>({
  leftTitle = 'Main Encounter',
  rightTitle = 'Comparison Encounter',
  leftContent,
  rightContent,
  component: Component,
  commonProps,
  leftProps,
  rightProps,
}: Props<T>) => {
  const renderLeft = () => {
    if (leftContent) return leftContent
    if (Component && (commonProps || leftProps)) {
      return <Component {...((commonProps || {}) as T)} {...((leftProps || {}) as T)} />
    }
    return null
  }

  const renderRight = () => {
    if (rightContent) return rightContent
    if (Component && (commonProps || rightProps)) {
      return <Component {...((commonProps || {}) as T)} {...((rightProps || {}) as T)} />
    }
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.column}>
        <div className={styles.header}>{leftTitle}</div>
        <div className={styles.content}>{renderLeft()}</div>
      </div>
      <div className={styles.column}>
        <div className={styles.header}>{rightTitle}</div>
        <div className={styles.content}>{renderRight()}</div>
      </div>
    </div>
  )
}
